/* Maison Mata — pages produits Lentilles de contact (refonte oct. 2026).
   Chargé seulement par le modèle product.contact-lenses (section « MM · Styles produits », extra_js).
   1. « Type · Acuvue Oasys BC 8.5 » / « Power · -1.00 » : valeur choisie à côté du nom de l'option.
   2. Lien du Journal (section texte qui suit les questions) placé à côté des questions.
   3. « You may also like » : les produits redirigés (verres du configurateur) ne sont pas proposés. */
(function () {
  'use strict';
  /* produits du modèle « lens-redirect » : leur page redirige vers la collection optique */
  var REDIRECTED = ['lenses-no-prescription', 'lenses-single-vision', 'plano-lens', 'single-vision-lens',
    'single-vision-lens-european', 'single-vision-lens-additinional-slimmer-lens-indo-european'];

  /* ---------- 1. valeur choisie à côté du nom de l'option ---------- */
  function legends() {
    document.querySelectorAll('variant-selects fieldset.product-form__input').forEach(function (fs) {
      var lg = fs.querySelector('legend');
      if (!lg) return;
      var c = fs.querySelector('input[type="radio"]:checked');
      var sp = lg.querySelector('.mm-lens-sel');
      if (!c) { if (sp) sp.remove(); return; }
      if (!sp) {
        sp = document.createElement('span');
        sp.className = 'mm-lens-sel';
        lg.appendChild(sp);
      }
      var v = ' · ' + c.value;
      if (sp.textContent !== v) sp.textContent = v;
    });
  }

  /* ---------- 2. lien du Journal à côté des questions ---------- */
  function journalLink() {
    var faq = document.querySelector('.mmf-section');
    if (!faq) return;
    var box = faq.querySelector('.mmf');
    var src = faq.nextElementSibling;
    if (!box || box.querySelector('.mm-lens-more') || !src || !/rich_text/.test(src.id)) return;
    var ps = src.querySelectorAll('.rich-text__text p');
    var links = src.querySelectorAll('.rich-text__buttons a[href]');
    if (!ps.length && !links.length) return;
    var more = document.createElement('div');
    more.className = 'mm-lens-more';
    ps.forEach(function (p) {
      var np = document.createElement('p');
      np.innerHTML = p.innerHTML;
      more.appendChild(np);
    });
    links.forEach(function (a) {
      var na = document.createElement('a');
      na.href = a.getAttribute('href');
      na.textContent = a.textContent.replace(/\s+/g, ' ').trim() + ' ';
      var arrow = document.createElement('span');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '↗';
      na.appendChild(arrow);
      more.appendChild(na);
    });
    box.appendChild(more);
    src.classList.add('mm-pp-moved');
  }

  /* ---------- 3. recommandations sans les produits redirigés ---------- */
  function cleanRelated(sec) {
    sec.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var h = (a.getAttribute('href') || '').split('?')[0].split('#')[0].replace(/\/$/, '').split('/products/').pop();
      if (REDIRECTED.indexOf(h) === -1) return;
      var item = a.closest('li') || a.closest('.grid__item') || a.closest('.card-wrapper');
      if (item && item.style.display !== 'none') item.style.display = 'none';
    });
  }
  function related() {
    document.querySelectorAll('#MainContent > .shopify-section').forEach(function (sec) {
      if (!/__related-products/.test(sec.id)) return;
      cleanRelated(sec);
      new MutationObserver(function () { cleanRelated(sec); }).observe(sec, { childList: true, subtree: true });
    });
  }

  function init() {
    legends();
    journalLink();
    related();
    var info = document.querySelector('.product__info-container');
    if (info) {
      info.addEventListener('change', function () { setTimeout(legends, 0); });
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(legends, 30); }).observe(info, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
